import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { authAPI } from "@/services/api";

const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    try {
      // Sign in with email and password using the API
      await authAPI.login(formData.email, formData.password);

      // The authAPI.login already saves tokens and redirects, no need to do it here
      
      // Redirect to home page
      window.location.href = "/";
    } catch (error) {
      setFormData({ ...formData, password: '' }); // Clear password field on error
      setError(t("Failed to log in. Please check your credentials."));
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-2xl font-semibold text-center text-gray-700 mb-6">
          {t("Login")}
        </h1>
        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            handleLogin();
          }}
        >
          <div>
            <label
              className="block text-sm font-medium text-gray-600 mb-1"
              htmlFor="email"
            >
              {t("Email")}
            </label>
            <input
              required
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              id="email"
              placeholder={t("Email")}
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
          </div>
          <div>
            <label
              className="block text-sm font-medium text-gray-600 mb-1"
              htmlFor="password"
            >
              {t("Password")}
            </label>
            <input
              required
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              id="password"
              placeholder={t("Password")}
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            />
          </div>
          {error && <p className="text-red-500 text-sm">{error}</p>}
          <button
            className="w-full py-3 px-4 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            type="submit"
          >
            {t("Login")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
